// extracted by mini-css-extract-plugin
module.exports = {"status":"style_status__7Gv80","pending":"style_pending__XfIWJ","successful":"style_successful__6ks9J","unsuccessful":"style_unsuccessful__Xagi0","withdraw":"style_withdraw__0PE3e"};